<template>
  <div
    v-if="
      product.feature_groups?.length ||
      isShowUserHelp ||
      (software && software.data.length > 0)
    "
    id="product-specifications"
    class="bg-white md:px-[7.777%] xl:px-[8.35%] 3xl:px-[152px]"
  >
    <div class="container">
      <div class="bg-white">
        <UiTabs>
          <UiTab
            v-if="product.feature_groups?.length"
            :name="$t('specification')"
          >
            <ProductFeatures
              :data="{
                items: product.feature_groups,
              }"
            />
          </UiTab>

          <UiTab v-if="isShowUserHelp" :name="$t('user_help')">
            <ProductUserHelp
              :manuals="product.documents?.manuals"
              :videos="product.documents?.videos"
              :faq-items="product.faqs"
            />
          </UiTab>

          <UiTab
            v-if="software && software.data.length > 0"
            :name="$t('software')"
          >
            <ProductSoftware :items="software.data" />
          </UiTab>
        </UiTabs>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ProductFeatures from '~/components/sections/productSection/ProductFeatures.vue';
import ProductUserHelp from '~/components/sections/productSection/ProductUserHelp.vue';
import ProductSoftware from '~/components/sections/productSection/ProductSoftware.vue';

interface Props {
  product?: any;
}

const props = withDefaults(defineProps<Props>(), {
  product: () => ({}),
});

const isShowUserHelp = computed(
  () =>
    props.product.documents?.manuals?.length > 0 ||
    props.product.documents?.videos?.length > 0 ||
    props.product.faqs?.length > 0,
);

const software = computed(() =>
  props.product?.content?.find(
    (item: { type: string }) => item.type === 'software-documents',
  ),
);
</script>
